<template>
    <CHeader data-aos-easing="linear" data-aos-duration="1500" id="el" class="navbars">
        <CHeaderBrand class="mx-auto" to="/index">
            <img src="../assets/img/flyhigh/logo.png" height="32px" class="m-2" alt="Interviewrr.ai company logo" />
        </CHeaderBrand>
    
        <CDropdown color="light" class="m-2 d-sm-flex d-lg-none" :caret="false">
            <template #toggler-content>
                                      <CIcon name="cil-justify-center" />
</template>
       
        <CDropdownItem to="/"
          >LAMAN UTAMA</CDropdownItem
        >

        <CDropdownItem to="OurProduct"
          > PRODUK KAMI</CDropdownItem
        >

        <CDropdownItem to="Teachers"
          >GURU KAMI</CDropdownItem
        >

        <CDropdownItem to="About"
          >TENTANG KAMI</CDropdownItem
        >

        <CDropdownItem to="StudentAchievement"
          >PENCAPAIAN KAMI</CDropdownItem
        >
        <CDropdownItem to="LearningPort"
          >NOTA BELAJAR</CDropdownItem
        >

        <CDropdownItem to="ContactUs"
          >HUBUNGI KAMI</CDropdownItem
        >

        <CDropdownItem to="ShoppingCart"
          > TROLI</CDropdownItem
        >

        <CDropdownItem href="https://app.flyhigh.my"
          >LOG MASUK</CDropdownItem
        >





 


      </CDropdown>
  
      <CHeaderNav class="d-md-down-none mr-auto">
        <CHeaderNavItem class="px-3">
          <CHeaderNavLink
            style="
            color: #fff;font-size: 16px;
font-style: normal;
font-weight: 500;
line-height: 24px;"
            to="/"
          >
            Laman Utama
          </CHeaderNavLink>
        </CHeaderNavItem>

        <CHeaderNavItem class="px-3">
          <CHeaderNavLink
            style="
               color: #fff;font-size: 16px;
font-style: normal;
font-weight: 500;
line-height: 24px;
            "
            to="/OurProduct"
          >
          Produk Kami
          </CHeaderNavLink>
        </CHeaderNavItem>


     
     

      

        <CHeaderNavItem class="px-3">
          <CHeaderNavLink
            style="
              color: #fff;font-size: 16px;
font-style: normal;
font-weight: 500;
line-height: 24px;
            "
            to="Teachers"
          >
           Guru Kami
          </CHeaderNavLink>
        </CHeaderNavItem>



        <CHeaderNavItem class="px-3">
          <CHeaderNavLink
            style="
              color: #fff;font-size: 16px;
font-style: normal;
font-weight: 500;
line-height: 24px;
            "
            to="About"
          >
           Tentang Kami
          </CHeaderNavLink>
        </CHeaderNavItem>

        <CHeaderNavItem class="px-3">
          <CHeaderNavLink
            style="
              color: #fff;font-size: 16px;
font-style: normal;
font-weight: 500;
line-height: 24px;
            "
            to="StudentAchievement"
          >
           Pencapaian Kami
          </CHeaderNavLink>
        </CHeaderNavItem>

       

        <CHeaderNavItem class="px-3">
          <CHeaderNavLink
            style="
              color: #fff;font-size: 16px;
font-style: normal;
font-weight: 500;
line-height: 24px;
            "
            to="LearningPort"
          >
          Nota Belajar
          </CHeaderNavLink>
        </CHeaderNavItem>

        <!-- <CHeaderNavItem class="px-3">
          <CHeaderNavLink
            style="
              color: #fff;font-size: 16px;
font-style: normal;
font-weight: 500;
line-height: 24px;
            "
            to="Package"
          >
          Pakej
          </CHeaderNavLink>
        </CHeaderNavItem> -->

        <CHeaderNavItem class="px-3">
          <CHeaderNavLink
            style="
              color: #fff;font-size: 16px;
font-style: normal;
font-weight: 500;
line-height: 24px;;
            "
            to="ContactUs"
          >
          Hubungi Kami
          </CHeaderNavLink>
        </CHeaderNavItem>


        <CHeaderNavItem class="px-3">
          <CHeaderNavLink
            style="
              color: #fff;font-size: 16px;
font-style: normal;
font-weight: 500;
line-height: 24px;
            "
            to="ShoppingCart"
          >
   <img src="../assets/img/cart.png" width="40px"/>
  </CHeaderNavLink>
</CHeaderNavItem>
        <CHeaderNavItem class="px-3">
  <a
    href="https://app.flyhigh.my"
    target="_blank"
    rel="noopener"
    style="color: #fff; font-size: 16px; font-style: normal; font-weight: 500;"
  >
    Log Masuk
  </a>
</CHeaderNavItem>

        <!-- <CHeaderNavItem class="px-3">
        <CHeaderNavLink
          style="
            color: #fff;
            font-family: 'Montserrat', sans-serif;
            font-weight: bold;
            font-size: 15px;
          "
        >
          <a
            href="#"
            onclick="doGTranslate('en|ms');return false;"
            title="Malay"
            class="glink nturl notranslate mr-2 text-white"
          >
            BM
          </a>
          |
          <a
            href="#"
            onclick="doGTranslate('ms|en');return false;"
            title="English"
            class="glink nturl notranslate ml-2 text-white"
          >
            EN
          </a>

          <span id="google_translate_element2" class="mr-2"></span>
        </CHeaderNavLink>
      </CHeaderNavItem> -->

      <!-- <div class="language-switcher">
    <button :class="{ active: currentLang === 'bm' }" @click="switchLang('bm')">BM</button>
    |
    <button :class="{ active: currentLang === 'en' }" @click="switchLang('en')">EN</button>
  </div> -->

      

     

  
      </CHeaderNav>
    </CHeader>
  </template>
      
<script>
import TheHeaderDropdownAccnt from "./TheHeaderDropdownAccnt";
import { langState, setLanguage } from '@/main.js'

export default {
    name: "TheHeader",
    components: {
        TheHeaderDropdownAccnt,
    },
    data() {
        return {
            Name: "",
            user: {}
        }
    },
    computed: {
        currentLang() {
            return langState.currentLang
        }
    },
    async mounted() {

        //this.GetInfoUser();

        if (localStorage.getItem("reloaded")) {
            // The page was just reloaded. Clear the value from local storage
            // so that it will reload the next time this page is visited.
            localStorage.removeItem("reloaded");
        } else {
            // Set a flag so that we know not to reload the page twice.
            localStorage.setItem("reloaded", "1");
            location.reload();
        }
    },
    methods: {


        GoToLogin() {
            this.router.push("Login");
        },
        switchLang(lang) {
            setLanguage(lang)
        }

    },
};
</script>

<style scoped>

</style>
  
  
  